import React from "react";
import { ViewContainerFabric } from "@msidentity/SISU/components/view-container/fabric/view-container-fabric";
import StylesConfigFabric from "@msidentity/SISU/config/styles-config";
import { FlowId, ViewId } from "@msidentity/SISU/constants/routing-constants";
import { useDocumentTitle } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/SISU/hooks/use-activate-view";
import { mergeClasses } from "@msidentity/SISU/utilities/merge-classes";
import { usernameRecoveryResultsViewStringsFabric as strings } from "../../../fabric/username-recovery-strings-fabric";
import { useRecoveryResults } from "../hooks/use-recovery-results";

/**
 * Collect Proof View Component for Username Recovery Flow
 * @returns instance of the view
 */
export const ResultsViewFabric: React.FC = function ResultsViewFabric() {
  const {
    proofState: { hasAssociatedAccounts, aliases },
    onSubmitHandler,
    title,
    description,
    heading,
    primaryButtonText,
  } = useRecoveryResults();

  useActivateView(ViewId.UsernameRecoveryResult, FlowId.UsernameRecovery, {
    showIdentityBanner: false,
  });
  useDocumentTitle(title);

  const { useCommonStyles } = StylesConfigFabric.instance;
  const commonStyles = useCommonStyles();

  const renderAssociatedAccountsUx = hasAssociatedAccounts && (
    <div className={commonStyles.row}>
      <div className={commonStyles.formGroup}>{heading}</div>
      <div role="list" className={commonStyles.formGroup}>
        {aliases.map((aliasName, index) => {
          const key = `${index}-aliasName`;
          return (
            <div
              key={key}
              role="listitem"
              className={mergeClasses(commonStyles.listItem, commonStyles.bold)}
            >
              {aliasName.name}
            </div>
          );
        })}
      </div>
      <div className={commonStyles.formGroup}>{strings.hiddenInfoForPrivacyDescription}</div>
    </div>
  );

  return (
    <ViewContainerFabric
      applyAriaLive
      title={{
        title,
      }}
      primaryButton={{
        label: primaryButtonText,
        type: "button",
        onClick: onSubmitHandler,
        hasFocus: true,
      }}
      description={description}
    >
      {renderAssociatedAccountsUx}
    </ViewContainerFabric>
  );
};
